import * as angular from 'angular';
import { gpCommon } from '../app';
import { ISimpleHttpService } from './authorized-http-service';

export interface IUploadService {
    uploadFiles(url: string, files: FileList): ng.IPromise<any>;
}

export class UploadService implements IUploadService {

    public static serviceName = "gpUploadService";

    constructor(public serviceBase: string, public $http: ISimpleHttpService, public $q: ng.IQService) {
    }

    public uploadFiles(url: string, files: FileList): ng.IPromise<any> {

        let deferred = this.$q.defer<any>();

        let fd = new FormData();

        for (let i = 0; i < files.length; ++i) {
            const file = files.item(i);
            if (file) {
                fd.append('file', file, file.name);
            }
        }

        let request = this.$http.post(url, fd,
            {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });

        request.then(result => deferred.resolve(result));
        request.catch(err => deferred.reject(err));

        return deferred.promise;
    }
}

gpCommon.factory(UploadService.serviceName, ['$httpAuth', '$q', function ($http: ISimpleHttpService, $q: ng.IQService) {

    let serviceBase = __gameplan_service_url || 'http://localhost/';

    return new UploadService(serviceBase, $http, $q);

}]);
